import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from 'material-react-toastify';
import { sharedStyles } from '../../utils/Style';
import { createProduct } from '../../api/Product';
import { Waiting } from '../../components/Waiting/Waiting';
import { ModifyProductFields } from './ModifyProductFields';
import { Product } from '../../interfaces/Product/Product';

export const NewProductPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const goBack = () => navigate('/products/catalog');

  const handleSave = (product: Product) => {
    setLoading(true);
    createProduct(product)
      .then((p) => {
        toast.success('Ürün başarıyla oluşturuldu');
        navigate(`/products/catalog/${p.id}`);
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody, p: 3 }}>
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>Yeni Ürün</Typography>
      </Box>
      <ModifyProductFields onSubmit={handleSave} />
    </Box>
  );
};
